<script>
    const plans = [
        {
            title    : 'SMB', 
            text     : 'Pequenas e médias empresas',
            value    : 'R$ 199,00',
            features : [
                { enabled: false, name: 'consentimentos' },
                { enabled: true , name: 'cookies'        },
                { enabled: true , name: 'políticas'      },
                { enabled: true , name: 'pedidos', details: 'até 10/mês (por site) *'},
            ],
            obs: []
        }, {
            title    : 'Business', 
            text     : 'O pacote completo para sua empresa',
            value    : 'R$ 499,00',
            features : [
                { enabled: true, name: 'consentimentos' },
                { enabled: true, name: 'cookies' },
                { enabled: true, name: 'políticas' },
                { enabled: true, name: 'pedidos', details: 'ilimitado' },
            ],
            obs: []
        }, {
            title    : 'DPO', 
            text     : 'Para encarregados de várias empresas',
            value    : 'R$ 399,00',
            features : [
                { enabled: true, name: 'consentimentos' },
                { enabled: true, name: 'cookies' },
                { enabled: true, name: 'políticas' },
                { enabled: true, name: 'pedidos', details: 'ilimitado' },
            ],
            obs: ['* valores decrescentes a cada 10 sites']
        }, {
            title    : 'Enterprise', 
            text     : 'Dogma no seu Datacenter',
            value    : 'Sob Consulta',
            features : [
                { enabled: true, name: 'consentimentos' },
                { enabled: true, name: 'cookies' },
                { enabled: true, name: 'políticas' },
                { enabled: true, name: 'pedidos', details: 'ilimitado' },
            ],
            obs: []
        }
    ]
</script>
<style>
    #plans {
        background-color: white;
        border-radius: 1em;
        margin: 2em 3em;
        padding-bottom: 2em;
    }

    :global(main.tiny) #plans {
        margin: 0;
        border-radius: 0;
    }

    .plans {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
        padding: 1em;
    }

    .plan {
        display: flex;
        flex-direction: column;
        border-radius: .6em;
        padding: 1em;
    }

    .title {
        margin: 0;
        font-size: 1.2em;
        font-weight: 400;
    }

    .value {
        font-size: 2em;
        font-weight: 700;
        white-space: nowrap;
    }

    .unit {
        color: var(--grey-color);
        vertical-align: super;
        font-size: 80%;
        font-weight: 300;
        margin-bottom: 1em;
    }

    .features {
        margin: 2em 0 0 0;
        flex: 1;
        font-size: 95%; 
    }

    .features > div {
        margin: 4px 0;
    }

    .feature span.name {
        margin-left: 8px;
    }

    .feature span.details {
        font-size: 85%;
        color: var(--light-grey-color);
    }

    .check {
        width: 16px;
        height: 16px;
        display: inline-block;
        -webkit-mask-image: url(/img/check.svg);
        mask-image: url(/img/check.svg);
    }

    .check.enabled {
        background-color: var(--green-color);
    }

    .check.disabled {
        background-color: var(--grey-color);
    }

    .observations {
        text-align: left;
        _align-self: flex-end;
        margin: 4em 0;
        color: var(--light-grey-color);
        font-size: 85%;
    }

    .plan a.purple {
        background: #fff;
        color: var(--purple-color);
        border: 1px solid var(--purple-color);
        text-align: center;
    }

    .plan:hover {
        background-color: var(--purple-color);
        _box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
        color: #fff;
    }

    @media(hover: hover) and (pointer: fine) {
        .plan:hover {
            background-color: var(--purple-color);
            color: #fff;
        }
    }

    .plan:hover .unit, .plan:hover .text, .plan:hover .enabled {
        color: #fff;
    }
    
</style>
<section id="plans" class="shadow">
    <div class="middle">
        <div class="header">
            <div class="centered title">
                <h1>Planos</h1>
            </div>
        </div>
        <div class="plans">
            {#each plans as plan}
                <div class="plan">
                    <div class="title">{plan.title}</div>
                    <div class="value">
                        {plan.value}
                        <!-- <span class="unit">/mês (por site)</span> -->
                    </div>
                    <div class="unit">
                        /mês (por site)
                    </div>
                    <div class="text">{plan.text}</div>
                    <div class="features">
                        {#each plan.features as feat}
                            <div class="feature">
                                {#if feat.enabled}
                                    <div class="check enabled"></div>
                                {:else}
                                    <div class="check disabled"></div>
                                {/if}
                                <span class="name">{feat.name}</span>
                                {#if feat.details}
                                    <span class="details">{feat.details}</span>
                                {/if}
                            </div>
                        {/each}
                    </div>
                    <div class="observations">
                        {#each plan.obs as observation}
                            <div>{observation}</div>
                        {/each}
                    </div>
                    <a class="button purple" href="https://console.dogma.legal/">Contratar</a>
                </div>
            {/each}
        </div>
    </div>
</section>